import { ConversationTypeEnum } from "./conversation";

export enum SystemOfRecord {
  VIN = "VIN",
  COMMON = "COMMON"
}

export enum SupportedIdP {
  IDS = "IDS",
  BRIDGE = "BRIDGE"
}

export interface SystemOfRecordConfig {
  customerSystem: SystemOfRecord;
}

export interface IdPConfig {
  getJwtOverride?: () => Promise<string>;
  supportedIdP: SupportedIdP;
  errorCallback: (errorMessage: string) => void;
}

export enum FeatureFlags {
  DisableReply = "DisableReply"
}

/**
 * Interface for inbox message handler that manages iframe postMessage communication
 */
export interface IInboxMessageHandler {
  handleMessage(event: MessageEvent): void;
  sendReadySignal(): void;
  sendCommunicationSent(
    communicationType: "EMAIL" | "TEXT" | "CALL",
    currentConversationType: ConversationTypeEnum,
    success: boolean,
    hasActiveTask: boolean,
    subject?: string,
    attachmentCount?: number
  ): void;
}

/**
 * Configuration for iframe-based communication between parent and child windows
 */
export interface IframeConfig {
  /** Hostname of the parent window */
  hostname: string;
  /** Message handler instance for iframe postMessage communication */
  handler: IInboxMessageHandler;
  /** Whether the application is running in iframe mode */
  isEnabled: boolean;
}
